import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=33d6aa13&scoped=true&"
import script from "./IconCheck.vue?vue&type=script&lang=ts&"
export * from "./IconCheck.vue?vue&type=script&lang=ts&"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=33d6aa13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d6aa13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
